import {
  ChartNoAxesCombined,
  CreditCard,
  Factory,
  FolderLock,
  HandCoins,
  Hospital,
  MonitorCog,
  Scale,
  ShoppingCart,
} from "lucide-react";

export const homeContent = {
  banner: {
    id: "1",
    primaryButton: {
      text: "Request Demo",
      url: "/contact#contactform",
    },
    secondaryButton: {
      text: "Start Your Free Trial",
      url: "/sign-up",
    },
    description:
      "Empower your business with state-of-the-art Generative AI solutions designed to enhance efficiency, accuracy, and growth. From telco to FSI, healthcare to government, we have delivered transformative AI solutions that drive real-world impact and value across industries.",
    imageURL: "https://cdn.inextlabs.ai/images/banner-images/banner-bg.png",
    title: "Democratizing AI to Empower Businesses Worldwide",
  },

  businessValueStatement: {
    statement:
      "Go beyond chatbots, IVR, and RPA to transform your business with advanced AI solutions encompassing Gen-AI powered data analytics, document intelligence, and process optimization.",
    imageURL: "https://cdn.inextlabs.ai/images/home/Creativity-pana.webp",
  },
  recognizationLogos: [
    {
      id: "1",
      imageURL: "https://cdn.inextlabs.ai/images/icons/home/ai-verify.webp",
      alt: "AI Verify",
    },
    {
      id: "2",
      imageURL: "https://cdn.inextlabs.ai/images/icons/home/data-ai.webp",
      alt: "Data AI",
    },
    {
      id: "3",
      imageURL: "https://cdn.inextlabs.ai/images/icons/home/mdlogo.webp",
      alt: "malaysia digital",
    },
    {
      id: "4",
      imageURL: "https://cdn.inextlabs.ai/images/icons/home/IMDA.webp",
      alt: "IMDA",
    },
  ],
  valueProps: [
    {
      id: "1",
      model: "model1",
      imageURL: "https://cdn.inextlabs.ai/images/home/expert-discuss.webp",
      title: "Tailored AI solutions for your business",
      description:
        "Unlock the power of Generative AI tailored to your business needs. Fine-tune models for enhanced accuracy and personalization, and maximize performance with Retrieval-Augmented Generation (RAG) for reliable, context-aware results.",
      descriptionOne:
        "<strong>Expert AI Guidance:</strong> Receive tailored recommendations to select the ideal Generative AI solution.",
      descriptionTwo:
        "<strong>Precision & Personalization:</strong>Fine-tune models for accurate, personalized outcomes.",
      descriptionThree:
        "<strong>Optimized Performance:</strong> Leverage Retrieval-Augmented Generation (RAG) for efficient, reliable AI outputs.",
    },
    {
      id: "2",
      model: "model1",
      imageURL: "https://cdn.inextlabs.ai/images/home/all-channel.webp",
      title: "Connect Seamlessly Across Channels",
      description:
        "Address your business needs with Gen AI, integrating seamlessly across Chat, Voice, and Avatar channels to unify systems and deliver a consistent, effective customer experience.",
      descriptionOne:
        "<strong>Unified Integration:</strong>Connect across Chat, Voice, and Avatar channels.",
      descriptionTwo:
        "<strong>Enhanced Communication:</strong>Boost operational efficiency and consistency.",
      descriptionThree:
        "<strong>Versatile Technology:</strong>Transform interactions and achieve impactful results.",
    },
    {
      id: "3",
      model: "model1",
      imageURL: "https://cdn.inextlabs.ai/images/home/security.webp",
      title: "Protect your AI initiatives with top-tier security",
      description:
        "Protect AI models in banking, insurance, and enterprise with comprehensive security solutions that ensure ethical standards and reliable performance.",
      descriptionOne:
        "<strong>Governance & Responsible AI:</strong> Implement strong governance frameworks to uphold ethical standards and ensure responsible AI use.",
      descriptionTwo:
        "<strong>LLM Protection:</strong>Safeguard Large Language Models against vulnerabilities for secure and reliable AI operations.",
      descriptionThree:
        "<strong>Deploy with Confidence:</strong> Ensure stability and compliance across all AI deployments, empowering your business to innovate securely.",
    },
  ],
  whyChooseUs: {
    title: "Why choose us",
    tagline: "Advanced, Adaptive, and Unmatched in Performance",
    content: [
      {
        id: "1",
        title: "All-in-One Solution",
        tagline: "A unified AI platform that integrates with your workflows",
        icon: <ChartNoAxesCombined size={25} />,
      },
      {
        id: "2",
        title: "Data Security",
        tagline:
          "Protects privacy with data masking, securing PII and sensitive info",
        icon: <FolderLock size={25} />, // Icon representing security
      },
      {
        id: "3",
        title: "Cost Efficient",
        tagline:
          "Optimizes with caching, token use, and fine-tuning for savings",
        icon: <HandCoins size={25} />, // Icon representing cost efficiency
      },
      {
        id: "4",
        title: "Hallucination Control",
        tagline:
          "Minimize errors with advanced detection and correction mechanism",
        icon: <MonitorCog size={25} />, // Icon representing AI assistance
      },
    ],
  },

  assistantSolutions: {
    title: "Intelligent AI solutions suite",
    tagline: "Driving Smart Decisions for Your Enterprise",
    content: [
      {
        id: "1",
        title: "inFlow Assistant",
        tagline:
          "Provide secure, reliable support with inFlow Assistant in chat, voice, and avatar forms across 40+ channels, enhancing accuracy and security for IT, HR, Customer Support, Sales, and more.",
        imageURL:
          "https://cdn.inextlabs.ai/images/home/solutions/ai-assistants.webp", // imageURL representing
        redirectURL: "/products/ai-assistants",
      },
      {
        id: "2",
        title: "inFlow Analyzer",
        tagline:
          "Leverage inFlow Analyzer to streamline workflows and make informed decisions with advanced, precise processing of documents, images, audio, and video across various sectors.",
        imageURL:
          "https://cdn.inextlabs.ai/images/home/solutions/ai-analyzer.webp", // imageURL representing security
        redirectURL: "/products/ai-analyzer",
      },
      {
        id: "3",
        title: "inFlow Insights",
        tagline:
          "Transform data into actionable insights with intuitive visualizations, empowering decision-making and driving significant value across your organization through real-time analytics and dynamic AI capabilities.",
        imageURL:
          "https://cdn.inextlabs.ai/images/home/solutions/ai-insights.webp", // Icon representing cost efficiency
        redirectURL: "/products/ai-insights",
      },
    ],
  },

  redirectPage: {
    imageURL: "https://cdn.inextlabs.ai/images/avatar-assistant/avatars.webp",
    title: " Give your business a face with AI Avatar Assistant",
    tagline:
      "Enhance customer interactions with Gen Al-powered Avatar Assistants. Offering human-like, multilingual communication, they deliver personalized, seamless experiences across industries, streamlining engagement and processes.",
    redirectURL: "/ai-avatar-assistant",
    buttonText: "Explore more",
  },
  testimonial: [
    {
      name: "Vidhya",
      position: "Director",
      id: "1",
      company: "Fit Formula",
      description:
        "As business owner, timely responding to my prospects is key to convert them as my customers. iNextLabs Notify saves me 5 hours every week in manual communications with my customers and provides me a peace of mind in tracking my messages to customers",
      imageURL: "https://cdn.inextlabs.ai/images/general/fit-formula-logo.png",
    },
    {
      name: "Ramasamy S",
      position: "Senior Manager",
      company: "Lakshmi Ceramics",
      id: "2",
      description:
        "we were looking for a user friendly, agent friendly one stop solution for handling queries within stipulated time and iNextLabs has perfectly provided our customers an overall delightful experience.When customers visit our website they head to the chat interface first, thus leads are well captured and hence our sales team loves iNextLabs.",
      imageURL: "https://cdn.inextlabs.ai/images/general/logo.svg",
    },
  ],
  partners: {
    title: "Our Strategic Partners in Driving Innovation & Excellence",
    logos: [
      {
        id: "1",
        imageURL:
          "https://cdn.inextlabs.ai/images/partners-logo/microsoft.webp",
        alt: "Microsoft",
      },
      {
        id: "2",
        imageURL: "https://cdn.inextlabs.ai/images/partners-logo/google.webp",
        alt: "Google",
      },
      {
        id: "3",
        imageURL: "https://cdn.inextlabs.ai/images/partners-logo/meta.webp",
        alt: "Meta",
      },
      {
        id: "4",
        imageURL:
          "https://cdn.inextlabs.ai/images/partners-logo/salesforce.webp",
        alt: "Salesforce",
      },
    ],
  },
  solutionFeatures: [
    {
      label: "Healthcare",
      desc: "Automate patient outreach, streamline appointment booking, and optimize onboarding for exceptional healthcare delivery.",
      icon: <Hospital />,
      pageURL: "https://inextlabs.ai/solution/healthcare",
    },
    {
      label: "BFSI",
      desc: "Enhance banking operations, loan processing, fraud detection, and customer service with AI-driven automation.",
      icon: <CreditCard />,
      pageURL: "https://inextlabs.ai/solution/bank",
    },
    {
      label: "Legal",
      desc: "Use AI solutions that guarantee accuracy and expedite procedures to improve case management and research efficiency.",
      icon: <Scale />,
      pageURL: "https://inextlabs.ai/solution/other-industries",
    },
    {
      label: "Manufacturing",
      desc: "Gain real-time insights, predictive maintenance, and increased operational efficiency by using AI to optimize manufacturing operations.",
      icon: <Factory />,
      pageURL: "https://inextlabs.ai/solution/other-industries",
    },
    {
      label: "Retail",
      desc: "Utilize AI to enhance inventory management and streamline retail operations for real-time demand forecasting and customisation.",
      icon: <ShoppingCart />,
      pageURL: "https://inextlabs.ai/solution/retail",
    },
  ],
  features: [
    {
      title: "Shared team inbox",
      className: "features-details-card-add",
      id: "1",
      description: "Centralize customer interactions across multiple channels.",
      imageURL: "https://cdn.inextlabs.ai/images/icons/inbox.svg",
    },
    {
      title: "Broadcasting",
      className: "features-details-card-even",
      id: "2",
      description: "Efficiently reach and engage with a large audience.",
      imageURL: "https://cdn.inextlabs.ai/images/icons/broadcast.svg",
    },
    {
      title: "Voice",
      className: "features-details-card-add",
      id: "3",
      description:
        "Human-like speech for accurate interpretation across channels.",
      imageURL: "https://cdn.inextlabs.ai/images/icons/microphone.svg",
    },
    {
      title: "Integrations",
      className: "features-details-card-even",
      id: "4",
      description: "Build conversational ecosystem with multiplicity.",
      imageURL: "https://cdn.inextlabs.ai/images/icons/integration.svg",
    },
  ],

  articles: [
    {
      id: "5",
      type: "News",
      imageURL: "https://cdn.inextlabs.ai/images/company/news/tech-outlook.png",
      publishedDate: "05 December 2023",
      title: `iNextLabs Celebrated as One of the "10 Most Promising Conversational AI Startups of 2023" by CIOTechOutlook`,
      url: "inextlabs-celebrated-as-one-of-the-10-most-promising-conversational-ai-startups-of-2023-by-ciotechoutlook",
      content: `<p class="para" >We at iNextLabs are thrilled to announce a significant milestone in our journey: CIOTechOutlook magazine has honored us as one of the ‘10 Most Promising Conversational AI Startups of 2023’. This recognition is a proud moment for our entire team and a testament to our dedication to innovation and excellence in the field of Conversational Artificial Intelligence (AI).</p><br/><p class="para" >In the rapidly evolving tech landscape, Conversational AI stands at the forefront, transforming how humans interact with machines. Our journey at iNextLabs has been focused on pushing the boundaries of this technology, ensuring that our solutions are not only innovative but also deeply resonant with the needs of our users.</p><br/><p class="para">Being recognized by CIOTechOutlook, a leader in technology insights and trends, is particularly meaningful for us. It underscores our position as a trailblazer in the industry, constantly striving to perfect the art and science of human-machine interaction.</p><br/><p class="para">This accolade is a collective achievement. It reflects the hard work, creativity, and vision of our dedicated team members who are the backbone of iNextLabs. Their unwavering commitment to excellence and their passion for technology have been crucial in shaping our success story.</p><br/><p class="para">Moreover, this achievement would not have been possible without our supportive community. Your trust in our vision and solutions motivates us to continue innovating and reaching new heights. Together, we are not just adapting to change – we are at the helm, driving it.</p><br/><p class="para">As we celebrate this recognition, we are also looking ahead. This accolade fuels our ambition to further advance in the field of Conversational AI. We are excited to continue our journey, exploring new possibilities, and setting new standards in the industry.</p><br/><p class="para">In conclusion, being named one of the ‘10 Most Promising Conversational AI Startups of 2023’ is a milestone that fills us with pride and gratitude. It’s a powerful reminder of how far we’ve come and a clear indication of the exciting path that lies ahead. At iNextLabs, we remain committed to our mission of making Conversational AI more intuitive, innovative, and accessible for everyone.</p><br/><p class="para">We extend our heartfelt thanks to CIOTechOutlook magazine, our incredible team, and our supportive community. Here’s to continuing our journey of innovation and excellence together!</p><br/><p class="para">Link to Magazine: <a href="https://www.ciotechoutlook.com/magazines/conversational-ai-startups-december-2023/#page=25">https://www.ciotechoutlook.com/magazines/conversational-ai-startups-december-2023/#page=25</a></p> `,
    },
    {
      id: "4",
      type: "News",
      imageURL: "https://cdn.inextlabs.ai/images/company/news/itransform.png",
      publishedDate: "08 November 2023",
      title: "iNextLabs Forms Strategic Alliance with itransform",
      url: "inextlabs-forms-strategic-alliance-with-itransform",
      content: `<p class="para">Singapore, November 2 — iNextLabs is delighted to announce a strategic alliance with iTransform, a dynamic entity in the realm of technology integration. This collaboration signifies a critical juncture as iNextLabs aims to extend its pioneering Generative-AI solutions to Australia and New Zealand.</p> <br/> <p class="para">Driven by a shared vision for technological advancement and business transformation, iNextLabs and itransform are joining forces to introduce a new era of possibilities in the realms of artificial intelligence.</p>  <br/> <p class="para">By harnessing iNextLabs’ cutting-edge Generative-AI solutions, this partnership endeavours to equip businesses in Australia and New Zealand with advanced tools to amplify creativity, drive efficiency, and innovation.</p> <br/>  <p class="para">“We are excited to join forces with itransform in this strategic alliance” said Dhandapani, Enterprise Sales Director, at iNextLabs. This collaboration represents a significant step forward in our mission to make advanced Generative-AI accessible to businesses worldwide. Australia and New Zealand are dynamic markets, and we are eager to contribute to their technological landscape.&quot;</p> <br/> <h1 class="sectionTitle margin left">About itransform:</h1> <p class="para">itransform was established with the visionary goal of assisting clients in innovating and streamlining their partnerships. At the heart of our mission is a passion for delivering tangible outcomes leveraging Data &amp; AI. We continually strive to merge our extensive knowledge, vast network, and tried-and-true methodologies to create a significant impact at scale. The brains behind iTransform, Puneet and Anu, boast over 25 years of experience working for Microsoft. Their collective expertise forms the foundation of our commitment – to leverage this wealth of experience in guiding our customers and partners towards optimizing their investments in Microsoft technologies and building successful practices.</p>      `,
    },
    {
      id: "3",
      type: "News",
      imageURL:
        "https://cdn.inextlabs.ai/images/company/news/New-Office-in-Malaysia.png",
      publishedDate: "27 September 2023",
      title: "iNextLabs Expands Global Presence with New Office in Malaysia",
      url: "inextlabs-expands-global-presence-with-new-office-in-malaysia",
      content: `<h1 class="sectionTitle left margin" >iNextLabs Expands Global Presence with New Office in Malaysia</h1><p class="para">[Kuala Lumpur, Sep 26] – We are excited to unveil a significant milestone in our global expansion journey. We proudly introduce our latest subsidiary office in Malaysia, marking a momentous step forward in our mission to transform customer experiences worldwide through cutting-edge Conversational AI-based solutions, including Chatbots and Voice bots.</p> <br/> <p class="para">Our newly inaugurated office in Kuala Lumpur, Malaysia, underscores our unwavering commitment to providing tailor-made support and innovative solutions that transcend geographical boundaries. We believe that opening an office in Malaysia will help us further strengthen the company’s position in the Southeast Asian market, offering a host of innovative solutions to empower both small and medium enterprises, as well as organizations in the region.</p> <br/> <p class="para">“Our presence in Malaysia reaffirms our dedication to serving businesses on a global scale. Regardless of your location, our personalized digital solutions are readily available to meet your unique needs. Businesses seeking to leverage technology for growth and efficiency will have access to iNextLabs’ expert consulting services, tailored to meet their unique needs,” said Mr. Murugappan, Co-founder and COO of iNextLabs.</p> <br/> <p class="para">The Malaysian Operations will be headed by Mr. Shanmugam Ganesan (aka Shan), an industry veteran with over 20 years of diverse global experience in creating, growing, and stabilizing new lines of business across various industry verticals in the Digital Engineering and Enterprise IT Services domain in the Asia Pacific. Before joining iNextLabs, Shan was with Deloitte Consulting SEA, where his extensive experience included strategy development, marketing and sales, organizational development, advisor relationships, leading large deals, and delivery execution.</p> <br/> <p class="para">“I am truly excited about the opening of iNextLabs’ subsidiary in Malaysia. This marks a significant milestone in our journey to bring cutting-edge innovation and technology solutions to this dynamic region. Our goal is to collaborate with local talent, foster innovation, and create a positive impact on businesses and communities. Together, we will shape the future of technology in Malaysia and beyond,” said Shan.</p> <br/> <p class="para">As we embark on this exciting new chapter, our core values of innovation, collaboration, and unwavering commitment to excellence continue to propel us forward. We eagerly anticipate making an even greater impact, forging new partnerships, and contributing to the global success of businesses.</p> <br/> <p class="para">Join us in celebrating this momentous milestone for iNextLabs. For inquiries, potential collaborations, or a deeper exploration of our digital solutions, please do not hesitate to reach out to us through our Contact Us page.</p><h1 class="sectionTitle left margin">About iNextLabs:</h1><p class="para">iNextLabs is a Singapore-based global company specializing in building Conversational AI-based Chatbots and Voice bots that help businesses redefine customer experiences. With a strong focus on innovation, iNextLabs empowers businesses and organizations to thrive in the digital age by harnessing the power of Generative-AI.</p>`,
    },
  ],

  clients: [
    "https://cdn.inextlabs.ai/images/client-logos/singtel_logo.png",
    "https://cdn.inextlabs.ai/images/client-logos/bank-rakyat.png",
    "https://cdn.inextlabs.ai/images/client-logos/cat.png",
    "https://cdn.inextlabs.ai/images/client-logos/vs-hospital-logo.png",
    "https://cdn.inextlabs.ai/images/client-logos/SC-LOGO-2048x2048.png",
    "https://cdn.inextlabs.ai/images/client-logos/Ishtara-logo.png",
    "https://cdn.inextlabs.ai/images/client-logos/asnb.png",
    "https://cdn.inextlabs.ai/images/client-logos/tsd.png",
    "https://cdn.inextlabs.ai/images/client-logos/anjappar-logo.png",
    "https://cdn.inextlabs.ai/images/client-logos/signarama-logo.png",
    "https://cdn.inextlabs.ai/images/client-logos/logo_miniktm.png",
    "https://cdn.inextlabs.ai/images/client-logos/ptdc.png",
    "https://cdn.inextlabs.ai/images/client-logos/logo-fullerton.png",
    "https://cdn.inextlabs.ai/images/client-logos/ew-logo.png",
    "https://cdn.inextlabs.ai/images/client-logos/junior-kuppanna.png",
    "https://cdn.inextlabs.ai/images/client-logos/lakshmi-ceraamics.png",
    "https://cdn.inextlabs.ai/images/client-logos/phonepe-logo.png",
    "https://cdn.inextlabs.ai/images/client-logos/tealive.png",
    "https://cdn.inextlabs.ai/images/client-logos/logo-ych.png",
    "https://cdn.inextlabs.ai/images/client-logos/shahi-maharani.png",
    "https://cdn.inextlabs.ai/images/client-logos/newsmart.png",
    "https://cdn.inextlabs.ai/images/client-logos/dp-architect.png",
    "https://cdn.inextlabs.ai/images/client-logos/vst_logo.png",
    "https://cdn.inextlabs.ai/images/client-logos/aurelius.png",
    "https://cdn.inextlabs.ai/images/client-logos/tn-logo.png",
    "https://cdn.inextlabs.ai/images/client-logos/isibensin.jpg",
    "https://cdn.inextlabs.ai/images/client-logos/jsa.png",
    "https://cdn.inextlabs.ai/images/client-logos/meta.png",
    "https://cdn.inextlabs.ai/images/client-logos/lisha-logo.png",
    "https://cdn.inextlabs.ai/images/client-logos/machans.png",
  ],
  meta: {
    title: "Building Agentic AI for Enterprise Excellence",
    description:
      "Empower your business with Generative AI to enhance efficiency, accuracy, and growth across industries.",
    locale: "en_US",
    siteName: "iNextLabs",
    image: "https://cdn.inextlabs.ai/images/banner-images/bg-banner-image.webp",
    type: "website",
  },
};
